import { render } from "./MarqueeText.vue?vue&type=template&id=ebe6d0cc"
import script from "./MarqueeText.vue?vue&type=script&lang=js"
export * from "./MarqueeText.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp64\\www\\comd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__